import React from "react";
import {
	Box,
	Alert,
	Link
} from "@mui/material";
import { LoadingStatusBox } from "../LoadingStatus/LoadingStatus";

const PermissionAlert = () => {
	return (
		<Alert severity="error">
			<Box className="alert-message">This page is blocked, please contact <Link href="mailto:support@gonini.com">support@gonini.com</Link> if you require access to this page.</Box>
		</Alert>
	);
};

export default function PermissionDependentView(props) {
	const permissions = props.userdata?.permissions;

	// null/undefined = permissions still loading. Empty Map = loaded with no grants.
	if (permissions == null) {
		return <LoadingStatusBox message={"Loading..."} marginBottom={5} />;
	}

	return permissions.has(props.permission) ? <>{props.children}</> : <PermissionAlert />;
}
